export const SET_SCROLL = 'SET_SCROLL';
export const SET_THEME = 'SET_THEME';
export const SET_LANGUAGE = 'SET_LANGUAGE';
